const { toEnum, permission, permissionsToRoleMap } = require('./utils');
const {
  CLIENT_ROLES: {
    CLIENT_OWNER,
  },
  CLIENT_ROLES,
} = require('./roles');

const CLIENT_PERMISSIONS = toEnum(
  'EDIT_USERS_CLIENT',
  'USAGE_CLIENT',
);

const DEFAULT_ROLE_PERMISSIONS_CLIENT = {
  [CLIENT_OWNER]: {
    ...permission(CLIENT_PERMISSIONS.EDIT_USERS_CLIENT),
    ...permission(CLIENT_PERMISSIONS.USAGE_CLIENT),
  },
};

const PERMISSIONS_TO_ROLE_MAP_CLIENT = permissionsToRoleMap(DEFAULT_ROLE_PERMISSIONS_CLIENT);

module.exports = {
  CLIENT_PERMISSIONS,
  DEFAULT_ROLE_PERMISSIONS_CLIENT,
  PERMISSIONS_TO_ROLE_MAP_CLIENT,
  CLIENT_ROLES,
};
